import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { tap } from 'rxjs/operators';
import { IRetrocession } from 'apps/idl/src/modules/patients/model/IRetrocession';
import { ContactsService } from 'apps/idl/src/services/security/contacts.service';
import { IContact } from 'apps/idl/src/model';

@Component({
	selector: 'di-retrocession-item',
	templateUrl: './retrocession-item.component.html',
	styleUrls: ['./retrocession-item.component.scss'],
})
export class RetrocessionItemComponent implements OnInit {
	@Input() public retrocession: IRetrocession;
	@Input() public selected: boolean = false;
	@Output() public retrocessionSelected = new EventEmitter<{ retrocession: IRetrocession }>();

	public period: string;
	public infirmierRemplace: string = '';

	constructor(
		private svcContact: ContactsService
	) {}

	ngOnInit(): void {
		this.svcContact.getContact(this.retrocession.createurId).pipe(
			tap((infirmier: IContact) => {
				this.infirmierRemplace = 'Pour ' + infirmier.firstName + ' ' + infirmier.lastName.toUpperCase();
				const options: Intl.DateTimeFormatOptions = {
					day: '2-digit',
					month: '2-digit',
					year: 'numeric'
				};		
				const start = new Date(this.retrocession.dateDebut).toLocaleDateString('fr-FR', options);
				const end = new Date(this.retrocession.dateFin).toLocaleDateString('fr-FR', options);
				this.period = `${start} - ${end}`;
			}),
		).subscribe();
	}

	public selectRetrocession(): void {
		this.retrocessionSelected.emit({ retrocession: this.retrocession });
	}
	
}